import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'app/core/http/api.service';
import { environment as env } from '@env/environment';

import { Router, ActivatedRoute } from '@angular/router';
import { CreditHoursService } from '../../../shared/services/credit-hours.service';

import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-live-test',
  templateUrl: './live.component.html',
  styleUrls: ['./live.component.css'],
})
export class LiveComponent implements OnInit {
  hall: string = '';
  textaraVal: string = '';
  name: string = '';

  userToken: string = '';
  result: any;
  speakers: any;
  questions: any;

  live_type: string = 'youtube';
  youtube: string = '';
  youtube1: string = '';
  youtube2: string = '';
  youtube3: string = '';
  youtube4: string = '';
  youtube5: string = '';
  youtube6: string = '';
  youtube7: string = '';
  youtube8: string = '';
  youtube9: string = '';

  vimeo: string = '';
  vimeo1: string = '';
  vimeo2: string = '';
  vimeo3: string = '';

  uid: string | null = null;

  is_admin = false;
  isGuest = false;
  guestUid: string | null = null;

  conference: any;
  conference_id: string = env.selectedEvent;
  errorMsg = '';
  isAuthorized = false;

  consentGiven = false;

  @HostListener('window:unload', ['$event'])
  unloadHandler(_evt: any) {}

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(_evt: any) {}

  constructor(
    private cookieService: CookieService,
    private apiServerice: ApiService,
    private router: Router,
    private cme: CreditHoursService,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog
  ) {
    const hallParam = this.activatedRoute.snapshot.paramMap.get('hall');
    this.hall = hallParam ?? '';

    const queryToken = this.activatedRoute.snapshot.queryParamMap.get('token');

    if (queryToken) {
      localStorage.setItem('token', queryToken);
      this.cookieService.set('token', queryToken, undefined, '/');
    }

    this.userToken =
      queryToken ||
      localStorage.getItem('token') ||
      this.cookieService.get('token') ||
      '';
    this.is_admin = Boolean(
      JSON.parse(this.cookieService.get('is_admin') || 'false')
    );

    this.isGuest = false;
    this.consentGiven = true;
  }

  ngOnInit(): void {
    if (!this.userToken) {
      this.redirectToLogin();
      return;
    }

    this.isAuthorized = true;
    this.initializeLivePage();
  }

  redirectToLogin(): void {
    localStorage.removeItem('token');
    this.cookieService.delete('token', '/');

    this.router.navigateByUrl('/login');
  }


  initializeLivePage(): void {
    this.doConference();
    // this.resolveModeratorRole();
    this.getQuestions();
    console.log(this.userToken);

    setInterval(() => {
      this.getQuestions();
    }, 10000);

    setInterval(() => {
      this.check_out();
    }, 1000 * 60 * 30);
  }

  openConsentDialog(uid: string, prefillName: string = ''): void {
    const dialogRef = this.dialog.open(ConsentDialogComponent, {
      disableClose: true,
      width: '520px',
      data: { uid, hall: this.hall || null, name: prefillName || '' },
    });

    dialogRef.afterClosed().subscribe(async (res?: { consent: boolean; name: string }) => {
      if (!res || !res.consent || !res.name?.trim()) {
        this.router.navigate(['/login'], {
          queryParams: { uid, hall: this.hall || undefined },
        });
        return;
      }

      this.name = res.name.trim();
      this.consentGiven = true;

      localStorage.setItem(`consent:${uid}`, '1');
      localStorage.setItem(`name:${uid}`, this.name);
    });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  doConference() {
    this.apiServerice.doGet(`conferences/${env.selectedEvent}`).subscribe((res) => {
      this.conference = res;
      this.live_type = this.conference.live_type;

      this.youtube1 = this.conference.youtube1;
      this.youtube2 = this.conference.youtube2;
      this.youtube3 = this.conference.youtube3;
      this.youtube4 = this.conference.youtube4;
      this.youtube5 = this.conference.youtube5;
      this.youtube6 = this.conference.youtube6;
      this.youtube7 = this.conference.youtube7;
      this.youtube8 = this.conference.youtube8;
      this.youtube9 = this.conference.youtube9;

      this.vimeo1 = this.conference.vimeo1;
      this.vimeo2 = this.conference.vimeo2;
      this.vimeo3 = this.conference.vimeo3;

      if (this.hall === 'a') {
        this.youtube = this.conference.youtube2;
        this.vimeo = this.conference.vimeo2;
      } else {
        this.youtube = this.conference.youtube1;
        this.vimeo = this.conference.vimeo1;
      }
    });
  }

  add_ques(form: any) {
    if (!this.userToken) {
      console.warn('No token – cannot submit question');
      return;
    }

    form.value.token = this.userToken;

    this.apiServerice
      .doPost(`questions/${env.selectedEvent}`, form.value)
      .subscribe((res) => {
        this.result = res;
      });

    this.textaraVal = '';
  }

  doSpeakers_old() {
    this.apiServerice
      .doGet(`conferences/${env.selectedEvent}/roles/2/members`)
      .subscribe((res) => {
        this.speakers = res;
      });
  }


  check_out() {
    this.cme.check_out('No');
  }

  goTo(location: string): void {
    window.location.hash = '';
    window.location.hash = location;
  }

  getQuestions() {
    this.apiServerice.doGet(`questions/${env.selectedEvent}`).subscribe((res) => {
      this.questions = res;
    });
  }

  openDialog(d_name: string, d_type = 'image') {
    const dialogRef = this.dialog.open(DialogAddQuestion, {
      data: {
        name: d_name,
        type: d_type,
        token: this.userToken,
        hall: this.hall || 'a',
      },
    });

    dialogRef.afterClosed().subscribe((_result) => {});
  }

  resolveModeratorRole(): void {
    this.apiServerice
      .doGet(`conferences/${env.selectedEvent}/roles/14/members`)
      .subscribe((res: any) => {
        const members = Array.isArray(res) ? res : [];

        const myToken =
          this.cookieService.get('token') ||
          localStorage.getItem('token') ||
          '';

        this.is_admin = members.some(
          (m) =>
            m?.token === myToken ||
            m?.is_me === true ||
            m?.id === 'me'
        );
      });
  }
}

@Component({
  selector: 'app-consent-dialog',
  template: `
    <h2 mat-dialog-title></h2>
    <mat-dialog-content>
      <p class="mb-3">
          <mat-checkbox [(ngModel)]="consent"> </mat-checkbox> *I confirm that I'm a healthcare

provider, resident of Bahrain / Kuwait / Oman / Qatar / United Arab Emirates, who is authorized and

licensed to prescribe and/or handle and/or perform clinical practice in

this(ese) country(ies).
      </p>

      <div class="mb-3">
      </div>

      <mat-form-field class="w-100" appearance="fill">
        <mat-label>Full Name</mat-label>
        <input matInput [(ngModel)]="name" />
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      <button mat-flat-button style="background-color: #e42f13ff; color: white;"
              (click)="confirm()"
              [disabled]="!consent || !name?.trim()">
      Watch Live
      </button>
    </mat-dialog-actions>
  `,
})
export class ConsentDialogComponent {
  consent = false;
  name = '';

  constructor(
    public dialogRef: MatDialogRef<ConsentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { uid: string; hall?: string | null; name?: string }
  ) {
    this.name = data?.name || '';
  }

  confirm() {
    this.dialogRef.close({ consent: this.consent, name: this.name });
  }
}

@Component({
  selector: 'dialog-add-question',
  templateUrl: 'dialog-add-question.html',
})
export class DialogAddQuestion {
  name = 'in Dialog';
  type = 'image';
  hall: string = 'a';
  textaraVal: string = '';

  userToken: string = '';
  conference_id: string = env.selectedEvent;
  result: any;
  speakers: any;

  linkVedio = 'https://player.vimeo.com/video/';

  constructor(
    private apiServerice: ApiService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      name: string;
      type: string;
      token: string;
      hall?: string;
    }
  ) {
    this.name = data.name;
    this.type = data.type;
    this.userToken = data.token;
    this.hall = data.hall || 'a';

    this.doSpeakers();
  }

  doSpeakers() {
    this.apiServerice
      .doGet(`conferences/${env.selectedEvent}/today_agenda_speakers`)
      .subscribe((res) => {
        this.speakers = res;
      });
  }

  add_ques(form: any) {
    if (!this.userToken) {
      console.error('DialogAddQuestion: userToken is missing');
      return;
    }

    this.apiServerice
      .doPost(
        `questions/${env.selectedEvent}?token=${encodeURIComponent(this.userToken)}`,
        form.value
      )
      .subscribe((res) => {
        this.result = res;
      });

    this.textaraVal = '';
  }
}